<template>
  <section class="views" @click="schoolNameList = []">
    <!-- header -->
    <headers select="-1"></headers>

    <!-- banner  -->
    <div class="posters">
      <van-image
        width="100%"
        :src="
          require(`@/assets/image/hodgepodge/pcbanner_${this.$i18n.locale}.jpg`)
        "
      />
      <!-- <div class="posters_ewm">
        <div class="ewm" @click="whatapp()">
          <div class="ewm2">
            <div class="ewm3">
              <img :src="require('@/assets/image/hodgepodge/ewm.png')" alt="" />
            </div>
            <div class="ewm3_value">
              <img :src="require('@/assets/image/wa.png')" alt="" /> 人工咨询
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <!-- from -->
    <div class="content">
      <div class="contentFrom_titleBox">
        <!-- <div class="contentFrom_title">參賽方式</div> -->
        <div class="contentFrom_title">{{ $t("signup.title") }}</div>
        <!-- 報名資料 -->
      </div>
      <div class="contentFrom_uls">
        <ul>
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">{{ $t("signup.competition_name") }}</div>
                <div class="listRight">
                  <input
                    type="text"
                    :placeholder="$t('signup.competition_name')"
                    v-model.trim="from.username"
                  />
                </div>
              </div>
              <div class="beizhu">
                *{{ $t("signup.name_must_match_id_number") }}
              </div>
            </div>
          </li>
          <li>
            <div class="list">
              <div class="listLeft">{{ $t("signup.gender") }}</div>
              <div class="listRight">
                <div class="listRight_xuan">
                  <van-popover
                    v-model="showSexPopover"
                    trigger="click"
                    :actions="sexActions"
                    @select="onSexSelect"
                  >
                    <template #reference>
                      <div
                        class="promptInputValue"
                        :class="sexIndex == -1 ? '' : 'placeholderValue'"
                      >
                        {{ from.sex_ }}
                      </div>
                    </template>
                  </van-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">出生地点</div>
                <div class="listRight">
                  <input
                    type="text"
                    placeholder="请输入与身份证明一致的出生地点"
                    v-model.trim="from.value1"
                  />
                </div>
              </div>
              <div class="beizhu">*输入须与身份证明一致的出生地点</div>
            </div>
          </li> -->
          <!-- <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">出生日期</div>
                <div class="listRight">
                  <div
                    style="
                      width: 100%;
                      display: flex;
                      justify-content: flex-end;
                      align-items: center;
                    "
                  >
                    <input
                      type="text"
                      :value="formattedDate"
                      placeholder="请选择出生日期"
                      readonly
                      @click="showDatePicker = true"
                      v-if="from.value2"
                    />
                    <div v-else class="right2" @click="showDatePicker = true">
                      选择日期
                    </div>
                  </div>

                  <van-dialog
                    v-model:show="showDatePicker"
                    title="选择出生日期"
                    show-cancel-button
                  >
                    <van-datetime-picker
                      v-model="from.value2"
                      type="date"
                      :min-date="minDate"
                      :max-date="maxDate"
                      @confirm="onConfirm"
                      @cancel="showDatePicker = false"
                    />
                  </van-dialog>
                </div>
              </div>
              <div class="beizhu">*输入须与身份证明一致的出生日期</div>
            </div>
          </li> -->
          <!-- <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">{{ $t("signup.age") }}</div>
                <div class="listRight">
                  <input
                    type="number"
                    :placeholder="$t('signup.select_age')"
                    v-model.trim="from.age"
                  />
                </div>
              </div>
            </div>
          </li> -->
          <li>
            <div class="list">
              <div class="listLeft">{{ $t("signup.e_mail") }}</div>
              <div class="listRight" style="display: flex">
                <input
                  type="text"
                  :placeholder="$t('signup.only_email_hint')"
                  v-model.trim="from.personInChargeEmail"
                />
              </div>
            </div>
          </li>
          <template v-if="!schoolCode">
            <li>
              <div class="list">
                <div class="listLeft">
                  {{ $t("signup.mobile_phone_number") }}
                </div>
                <div class="listRight">
                  <div class="listRight_sji">
                    <div class="left" style="cursor: pointer">
                      <van-popover
                        v-model="mobilePhoneActionsShow"
                        placement="bottom"
                        trigger="click"
                        :actions="mobilePhoneActions"
                        @select="onmobilePhoneSelect"
                      >
                        <template #reference>
                          <div
                            class="promptInputValue"
                            :class="gradeIndex == -1 ? '' : 'placeholderValue'"
                          >
                            {{ from.code }}
                            <span
                              :class="{ '': true, left_formTwo: showPickerTwo }"
                            >
                              <van-icon
                                name="arrow-down"
                                size="12"
                                color="#333333"
                              />
                            </span>
                          </div>
                        </template>
                      </van-popover>
                    </div>

                    <div class="right">
                      <input
                        type="number"
                        :placeholder="$t('signup.only_phone_hint')"
                        v-model.trim="from.personInChargePhone"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="list">
                <div class="listLeft">{{ $t("signup.phone_note") }}</div>
                <div class="listRight">
                  <div class="listRight_xuan">
                    <van-popover
                      v-model="showRemarkPopover"
                      trigger="click"
                      :actions="remarkActions"
                      @select="onRemarkSelect"
                    >
                      <template #reference>
                        <div
                          class="promptInputValue"
                          :class="remarkIndex == -1 ? '' : 'placeholderValue'"
                        >
                          {{ from.remark }}
                        </div>
                      </template>
                    </van-popover>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="list2">
                <div class="list2_uls">
                  <div class="listLeft">{{ $t("signup.your_city") }}</div>
                  <div class="listRight">
                    <input
                      type="text"
                      :placeholder="$t('signup.enter_city_in_indonesia')"
                      v-model.trim="from.studentRegion"
                    />
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="list2">
                <div class="list2_uls">
                  <div class="listLeft">{{ $t("signup.your_school") }}</div>
                  <div class="listRight">
                    <input
                      type="text"
                      :placeholder="$t('signup.enter_full_school_name')"
                      v-model.trim="from.currentSchool"
                    />
                  </div>
                </div>
                <div class="beizhu">
                  *{{ $t("signup.individual_registration_requires_school") }}
                </div>
              </div>
            </li>
            <li>
              <div class="list2">
                <div class="list2_uls">
                  <div class="listLeft">{{ $t("signup.grade") }}</div>
                  <div class="listRight">
                    <div class="listRight_xuan">
                      <van-popover
                        v-model="showGradePopover"
                        placement="right"
                        trigger="click"
                        :actions="gradeActions"
                        @select="onGradeSelect"
                      >
                        <template #reference>
                          <div
                            class="promptInputValue"
                            :class="
                              gradeIndex == '-1' ? '' : 'placeholderValue'
                            "
                          >
                            {{ from.gradeName }}
                          </div>
                        </template>
                      </van-popover>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="list2">
                <div class="list2_uls">
                  <div class="listLeft">
                    {{ $t("signup.competition_group") }}
                  </div>
                  <div class="listRight">
                    <input
                      type="text"
                      placeholder=""
                      v-model.trim="competitionGroup"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </li>
            <!-- <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">指导老师姓名</div>
                <div class="listRight">
                  <input
                    type="text"
                    placeholder="请输入指导老师姓名"
                    v-model.trim="from.teacherName"
                  />
                </div>
              </div>
            </div>
          </li> -->
            <!-- <li>
              <div class="list">
                <div class="listLeft">手机验证码</div>
                <div class="listRight">
                  <div class="listRight_sji2">
                    <div class="right">
                      <input
                        type="text"
                        placeholder="请输入验证码"
                        v-model.trim="from.verifyCode"
                      />
                    </div>
                    <div
                      class="right2"
                      @click="CodeBln ? clickNumberCodeFnc() : ''"
                      v-html="codeMsg"
                    ></div>
                  </div>
                </div>
              </div>
            </li> -->
          </template>

          <!-- <li>
            <div class="list">
              <div class="listLeft">就讀學校</div>
              <div class="listRight listPan" style="display: flex">
                <input
                  v-if="!schoolCode"
                  type="text"
                  placeholder="請輸入參賽者就讀學校"
                  v-model.trim="searchCampus"
                  @click.stop="getHkSchoolList()"
                />
                <input
                  v-if="schoolCode"
                  type="text"
                  placeholder="請輸入參賽者就讀學校"
                  v-model.trim="searchCampus"
                  disabled
                  style="cursor: not-allowed"
                />

                <div class="posText" v-if="schoolNameList.length != 0">
                  <ul>
                    <li
                      v-for="(item, index) in schoolNameList"
                      :key="index"
                      @click.stop="zhiyin(item)"
                      style="font-size: 14px"
                    >
                      {{ item.schoolName }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li> -->
        </ul>
        <!-- <div class="uls_beizhu">
          * 如學校/機構 進行統一報名參賽，請切換到【學校報名】<br />*
          特殊學校-閃亮組 請通過學校老師進行統一報名，請老師切換到【學校報名】
        </div> -->
      </div>

      <div class="fromButtom" @click="Frombuttom">
        {{ $t("other_pages.submit_registration") }}
        <!-- <img :src="require('@/assets/image/hodgepodge/tjbm.png')" alt="" /> -->
      </div>
      <!-- <div class="timeUp"><div>報名已結束</div></div> -->
    </div>

    <!-- 展位 -->
    <div style="width: 100%"></div>

    <!-- 性别 -->
    <van-popup
      v-model="showPicker"
      position="bottom"
      :style="{
        'min-height': '30%',
        'max-width': '944px',
        margin: 'auto',
        right: '0',
        left: '0',
      }"
    >
      <van-picker
        show-toolbar
        :columns="sexColumns"
        @confirm="onSexConfirm"
        @cancel="showPicker = false"
        :confirm-button-text="$t('other_pages.confirm')"
        :cancel-button-text="$t('other_pages.cancel')"
      />
    </van-popup>
    <!-- code -->
    <van-popup
      v-model="showPickerTwo"
      position="bottom"
      :style="{
        'min-height': '30%',
        'max-width': '944px',
        margin: 'auto',
        right: '0',
        left: '0',
      }"
    >
      <van-picker
        show-toolbar
        :columns="mobilePhoneColumns"
        @confirm="onPhoneConfirm"
        @cancel="showPickerTwo = false"
        :confirm-button-text="$t('other_pages.confirm')"
        :cancel-button-text="$t('other_pages.cancel')"
      />
    </van-popup>
  </section>
</template>

<script>
import headers from "@/components/header/pc_header";
import selectBox from "./components/select";
import publics from "@/mixin/public_mixin";
import home from "@/mixin/home_mixin";
export default {
  name: "signup",
  data() {
    return {
      showSexPopover: false,
      showRemarkPopover: false,
      sexActions: [
        {
          text: this.$t("signup.male"),
          id: "male",
        },
        {
          text: this.$t("signup.female"),
          id: "female",
        },
      ],
      remarkActions: [
        {
          text: this.$t("signup.own"),
          id: 0,
        },
        {
          text: this.$t("signup.father_s"),
          id: 1,
        },
        {
          text: this.$t("signup.mother_s"),
          id: 2,
        },
        {
          text: this.$t("signup.teacher_s"),
          id: 3,
        },
      ],
      sexIndex: -1,
      remarkIndex: -1,
      showGradePopover: false,
      gradeActions: [
        { text: this.$t("signup.junior_high_grade_1"), code: "S1" },
        { text: this.$t("signup.junior_high_grade_2"), code: "S2" },
        { text: this.$t("signup.junior_high_grade_3"), code: "S3" },
        { text: this.$t("signup.senior_high_grade_1"), code: "S4" },
        { text: this.$t("signup.senior_high_grade_2"), code: "S5" },
        { text: this.$t("signup.senior_high_grade_3"), code: "S6" },
        { text: this.$t("signup.university_year_1"), code: "U1" },
        { text: this.$t("signup.university_year_2"), code: "U2" },
        { text: this.$t("signup.university_year_3"), code: "U3" },
        { text: this.$t("signup.university_year_4"), code: "U4" },
      ],
      gradeIndex: "-1",

      dqiSelectIndex: -1, //默認0
      dqiSelectIndex2: -1, //默認不選擇

      mobilePhoneActionsShow: false,
      mobilePhoneActions: [
        {
          text: "+62",
          id: 0,
        },
        // {
        //   text: "+86",
        //   id: 1,
        // },
      ],

      showPickerschool: false,
      diqu: [],
      cities: {},
      from: {
        username: "",
        sex: this.$t("signup.select_participant_gender"), //-1 未选中  0男  1女
        sex_: this.$t("signup.select_participant_gender"), //-1 未选中  0男  1女
        code: "+62", //区号
        personInChargePhone: "", //手机号
        verifyCode: "", //手机验证码
        grade: this.$t("signup.select_participant_grade"), //年级
        gradeName: this.$t("signup.select_participant_grade"), //年级
        remark: this.$t("signup.select_phone_owner"), //手机号备注
        personInChargeEmail: "", //邮件
        school_address: "", //地区
        schoolName: "", //就读学校
        agencyName: "", // 参赛学校
        value1: "", // 出生地点
        value2: "", // 出生日期
        age: "", // 年龄
        studentRegion: "", // 所在城市
        currentSchool: "", // 所在学校
      },
      searchCampus: "",
      showPicker: false,
      showPickerTwo: false,
      groups: [
        {
          code: 1,
          name: this.$t("signup.group_a"),
        },
        {
          code: 2,
          name: this.$t("signup.group_b"),
        },
        {
          code: 3,
          name: this.$t("signup.group_c"),
        },
      ],
      competitionGroup: "",
      groupId: "",

      sexColumns: ["请选择参赛者性别", "男", "女"],
      mobilePhoneColumns: ["+62", "+86"], //区号

      CodeBln: true,
      timer: null, //清空时间
      countdown: 60,
      codeMsg: "获取验证码",

      newAddress: [], //地區
      schoolNameList: [], //提示
      diquaddRess: [], //原始
      diquaddRess2: [],
      disableWatch: false,
      competitionAccountId: "",
      schoolCode: "",
      // schoolCode: '578126',
      // competitionAccountId: 'afG6Q3',
      showDatePicker: false,
      minDate: new Date(1970, 0, 1),
      maxDate: new Date(),
    };
  },
  computed: {},
  mixins: [publics, home],
  components: {
    headers,
    selectBox,
  },
  watch: {
    "from.value2": function (newVal) {
      this.formattedDate = this.formatDate(newVal);
    },
    newAddress(val) {
      if (val) {
        console.log(val);
        this.schoolNameList = [];
        this.from.schoolName = "";
        this.from.agencyName = "";
        this.searchCampus = "";
      }
    },
    searchCampus: {
      immediate: true,
      handler(val) {
        if (!this.disableWatch) {
          this.from.schoolName = "";
          this.from.agencyName = "";
          if (this.newAddress.length != 0) {
            if (val.length != 0) {
              this.getHkSchoolList(val);
            } else {
              this.schoolNameList = [];
              this.getHkSchoolList();
            }
          }
        } else {
          this.disableWatch = false;
        }
      },
    },
    showPickerschool(val) {
      console.log(val);
    },
  },
  created() {
    // this.getAddressList();
    // this.getSchoolData()
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    //避免元素銷毀還繼續監聽
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    onConfirm(value) {
      this.from.value2 = value;
      this.showDatePicker = false;
    },
    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = `0${d.getMonth() + 1}`.slice(-2);
      const day = `0${d.getDate()}`.slice(-2);
      return `${year}-${month}-${day}`;
    },
    getSchoolData() {
      const params = {
        schoolNo: this.schoolCode,
      };
      this.$axios({
        url: this.$api.getSchoolByCode,
        method: "get",
        params: params,
      }).then((response) => {
        const { data } = response.data;
        if (response.data.code == 0) {
          const { schoolRegion, schoolRegion1, schoolName } = data;
          this.newAddress[0] = schoolRegion;
          this.newAddress[1] = schoolRegion1;
          // this.schoolNameList = [{ schoolName }]
          this.disableWatch = true;
          this.from.schoolName = schoolName;
          this.searchCampus = schoolName;
        }
      });
    },
    whatapp() {
      this.home_mdevInit();
      window.open(this.whatUrl, "_blank");
    },
    onmobilePhoneSelect(action) {
      this.from.code = action.text;
    },
    isNumber(value) {
      return typeof value === "number";
    },
    // 電郵驗證
    validator_email(val) {
      const email = val.trim();
      return /^[A-Za-z0-9]+([_\-\.][A-Za-z0-9]+)*@([A-Za-z0-9\-\_]+\.)+[A-Za-z]{2,6}$/.test(
        email
      );
    },
    toggleElement() {
      this.showPickerschool = !this.showPickerschool;
    },
    handleClickOutside(event) {
      if (
        this.$refs.elementDQ &&
        !this.$refs.elementDQ.contains(event.target)
      ) {
        this.showPickerschool = false;
      }
    },
    onselectDqBut(event, index) {
      this.dqiSelectIndex = index;
      this.diquaddRess2 = event.data;
      this.dqiSelectIndex2 = 0;
      this.newAddress[0] = event.title;
      this.newAddress[1] = event.data[0];
    },
    onselectDqBut2(event, index) {
      if (this.dqiSelectIndex != -1) {
        this.dqiSelectIndex2 = index;
        this.newAddress[1] = event;
      } else {
        this.$toast("請先選擇區域");
      }
    },
    onSexSelect(action) {
      this.sexIndex = action.id;
      this.from.sex = action.id;
      this.from.sex_ = action.text;
    },
    onRemarkSelect(action) {
      this.remarkIndex = action.code;
      this.from.remark = action.text;
    },
    // 分配组别
    onGradeSelect(action) {
      console.log(action);
      this.gradeIndex = action.code;
      this.from.grade = action.code;
      this.from.gradeName = action.text;

      if (["S1", "S2", "S3"].includes(action.code)) {
        this.groupId = this.groups[0].code;
        this.competitionGroup = this.groups[0].name;
      } else if (["S4", "S5", "S6"].includes(action.code)) {
        this.groupId = this.groups[1].code;
        this.competitionGroup = this.groups[1].name;
      } else if (["U1", "U2", "U3", "U4"].includes(action.code)) {
        this.groupId = this.groups[2].code;
        this.competitionGroup = this.groups[2].name;
      } else {
        console.log("未匹配");
        this.groupId = "";
        this.competitionGroup = "";
      }
      // console.log('pc', this.groupId, this.competitionGroup)
    },

    zhiyin(e) {
      this.disableWatch = true;
      this.searchCampus = e.schoolName;
      this.$nextTick(() => {
        this.from.schoolName = e.schoolName;
        this.from.agencyName = e.schoolName;
        this.schoolNameList = [];
      });
    },
    onAddressChange(picker, value, index) {
      picker.setColumnValues(1, this.cities[value[0]]);
      this.newAddress = value;
    },
    onAddressConfirm(e) {
      console.log(e);
      this.newAddress = e;
      this.showPickerschool = false;
    },
    getAddressList() {
      this.$axios
        .get(this.$api.getHkSchoolRegion)
        .then((res) => {
          // console.log(res)
          if (res.data.code == 0) {
            let data = res.data.data;
            this.diquaddRess = data;
            this.diquaddRess2 = data[0].data;

            // console.log(this.diquaddRess2)
            const cities = data.reduce((result, { title, data }) => {
              result[title] = data;
              return result;
            }, {});
            // console.log(cities)
            this.cities = cities;
            this.diqu = [
              {
                values: Object.keys(cities),
              },
              {
                values: cities["港島區域"],
              },
            ];
          }
        })
        .catch((res) => {
          console.log("失败", res);
        });
    },
    getHkSchoolList(e) {
      let params = {
        schoolRegion: this.newAddress[0],
        schoolRegion1: this.newAddress[1],
        schoolName: e,
      };
      this.$axios({
        url: this.$api.getHkSchool,
        method: "get",
        params: params,
      })
        .then((res) => {
          // console.log(res)
          let data = res.data.rows;
          if (res.data.code == 0) {
            this.schoolNameList = [];
            this.schoolNameList = data;
          }
        })
        .catch((res) => {
          console.log("失败", res);
        });
    },
    validator_phone(val) {
      const phone = val;
      return /^[0-9]*$/.test(phone);
    },
    // 验证码
    clickNumberCodeFnc() {
      let { code, personInChargePhone } = this.from;
      // console.log(code, personInChargePhone)
      if (personInChargePhone == null || personInChargePhone == "") {
        this.$toast.fail("請檢查您的手機號");
        return;
      }

      if (!this.validator_phone(personInChargePhone)) {
        this.$toast("手機號格式有誤 !");
        return;
      }

      const phoneList = [];
      const prefix = code;
      // const prefix = code.replace('+', '')
      phoneList.push(prefix + "-" + personInChargePhone);
      const params = {
        appType: 12,
        verifyType: 9,
        phoneList,
        smsTemplateType: 10,
        signType: 1,
      };

      this.$toast.loading({
        message: this.$t('achievement.querying'),
        forbidClick: true,
        duration: 0,
      });
      let sendUrl = this.$api.sendSmsForSecondCup;
      this.$axios({
        url: sendUrl,
        method: "post",
        data: params,
      })
        .then((response) => {
          console.log("response", response);
          if (response.data.code == 0) {
            this.$toast.clear();
            this.$toast.success("验证码获取成功");
            let that = this;
            clearInterval(that.timeIntinvel);
            that.CodeBln = false;
            let index = 60;

            that.timeIntinvel = setInterval(() => {
              index--;
              if (index <= 0) {
                index = 0;
                that.CodeBln = true;
                that.codeMsg = "获取验证码";
              } else {
                that.codeMsg = `${index}S`;
              }
            }, 1000);
          } else {
            this.$toast.fail("验证码获取失败");
          }
        })
        .catch((error) => {
          //请求失败
          this.$toast.clear();
          this.$toast.fail("error");
          console.log(error);
        });
    },
    getQueryString: function (name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    // 表單
    Frombuttom() {
      // console.log(this.from, "from");
      const {
        username,
        code,
        personInChargePhone,
        verifyCode,
        personInChargeEmail,
        sex,
        grade,
        currentSchool,
        studentRegion,
        studentCode,
        password,
        remark,
      } = this.from;
      if (username == "" || username == null) {
        this.$toast.fail(this.$t("signup.competition_name"));
        return;
      }
      if (personInChargePhone == "" || personInChargePhone == null) {
        this.$toast.fail(this.$t("signup.only_phone_hint"));
        return;
      }
      if (!this.validator_phone(personInChargePhone)) {
        this.$toast.fail(this.$t("signup.pls_enter_correct_phone"));
        return;
      }
      if (remark == "" || remark == this.$t("signup.select_phone_owner")) {
        this.$toast.fail(this.$t("signup.select_phone_owner"));
        return;
      }
      // if (verifyCode == "" || verifyCode == null) {
      //   this.$toast.fail("请输入验证码");
      //   return;
      // }
      if (personInChargeEmail == "" || personInChargeEmail == null) {
        this.$toast.fail(this.$t("signup.only_email_hint"));
        return;
      }
      if (!this.validator_email(personInChargeEmail)) {
        this.$toast(this.$t("signup.pls_enter_correct_email"));
        return;
      }

      if (sex == this.$t("signup.select_participant_gender") || sex == -1) {
        this.$toast.fail(this.$t("signup.select_participant_gender"));
        return;
      }

      if (
        grade == this.$t("signup.select_participant_grade") ||
        grade == null
      ) {
        this.$toast.fail(this.$t("signup.select_participant_grade"));
        return;
      }

      // if (this.newAddress.length == 0) {
      //   this.$toast.fail("選擇學校地區");
      //   return;
      // }

      if (studentRegion == "" || studentRegion == null) {
        this.$toast.fail(this.$t("signup.enter_city_in_indonesia"));
        return;
      }
      if (currentSchool == "" || currentSchool == null) {
        this.$toast.fail(this.$t("signup.enter_full_school_name"));
        return;
      }
      const params = {
        studentName: username, // 姓名
        sex, // 性别
        phone: personInChargePhone, //手机号
        phoneAttribution: remark,
        grade, // 年级
        prefix: code.replace(/\+/g, ""), //区号
        email: personInChargeEmail,
        verifyCode: "0923", // 验证码
        studentRegion, // 城市
        currentSchool, // 学校
        // competitionGroup: this.competitionGroup, // 组别
        groupId: this.groupId, // 组别id
        competitionType: 9, // 比赛类型
        // studentCode,
        // password,
        // schoolCode: this.schoolCode,
        // competitionAccountId: this.competitionAccountId,
        // platform: 'PC',
        platform: !localStorage.getItem("c") ? "PC" : localStorage.getItem("c"),
      };
      console.log("提交", params);
      this.$toast.loading({
        message: "loading...",
        forbidClick: true,
        duration: 0,
      });
      // this.$api.signUpByStudentCode 学号注册
      // this.$api.fromSaveSingle 普通个人注册
      this.$axios({
        url: this.$api.fromSaveSingle,
        method: "post",
        data: params,
      })
        .then((response) => {
          // console.log(response)
          if (response.data.code == 0) {
            this.$toast.clear();
            // this.$toast.success(this.$t("signup.submit_success"));
            console.log(response.data.data, "data");
            const data = response.data.data;
            const { accountName, isNewUser, password } = data;
            this.$router.replace({
              path: "/successful",
              query: { accountName, password, isNewUser },
            });
            // sessionStorage.setItem("schoolCode", "");
            // sessionStorage.setItem("competitionAccountId", "");
          } else {
            this.$toast.clear();
            this.$toast.fail(response.data.msg);
          }
        })
        .catch((error) => {
          //请求失败
          this.$toast.clear();
          this.$toast.fail("error");
          console.log(error);
        });

      // this.$router.push("/successful");
    },
    onSexConfirm(e) {
      console.log(e);
      this.from.sex = e;
      this.showPicker = false;
    },
    sexBut() {
      this.showPicker = true;
    },
    pickerPhoneBut() {
      this.showPickerTwo = true;
    },
    onPhoneConfirm(e) {
      console.log(e);
      this.from.code = e;
      this.showPickerTwo = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.views {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  background: #ff782f;

  .posters {
    width: 100%;
    display: flex;
    position: relative;

    img {
      width: 100%;
    }

    .posters_ewm {
      position: absolute;
      width: 1024px;
      left: 0;
      right: -10%;
      bottom: 0;
      top: 0;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: right;

      .ewm {
        width: 161px;
        min-height: 189px;
        background: rgba(255, 255, 255, 0.63);
        border-radius: 16px 16px 16px 16px;
        padding: 8px;
        box-sizing: border-box;
        cursor: pointer;

        .ewm2 {
          width: 100%;
          height: 100%;
          padding: 6px;
          background: #fdcf1d;
          border-radius: 12px 12px 12px 12px;
          box-sizing: border-box;

          .ewm3 {
            width: 132px;
            height: 132px;
            background: #ffffff;
            border-radius: 8px 8px 8px 8px;
            margin-bottom: 6px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .ewm3_value {
            width: 100%;
            height: 40px;
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #323232;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            background: url("~@/assets/image/icon/ewmbut.png") no-repeat;
            background-size: 100% 100%;
            box-shadow: inset 0px 1px 4px 0px rgba(234, 138, 7, 0.48),
              inset 0px -5px 3px 0px rgba(255, 227, 129, 0.57);
            vertical-align: middle; /* 将文本和图片垂直居中对齐 */

            img {
              width: 20px;
              height: 20px;
              margin-right: 4px;
              vertical-align: middle; /* 将图片和文本垂直居中对齐 */
            }
          }
        }
      }
    }
  }

  .content {
    width: 100%;
    max-width: 944px;
    margin: auto;
    margin-top: 83px;
    margin-bottom: 30px;

    // min-height: 795px;
    background: #ffffff;
    box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 16px;

    padding-bottom: 26px;

    .contentFrom_titleBox {
      width: 100%;
      height: 52px;
      position: relative;

      .contentFrom_title {
        width: 300px;;
        height: 52px;
        margin: auto;
        border-radius: 9px;
        background: url("~@/assets/image/icon/titlebg.png") no-repeat;
        background-size: 100% 100%;
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 52px;
        position: absolute;
        top: -47%;
        left: 0;
        right: 0;
        margin: auto;

        text-shadow: 1.5px 1.5px 0 #ff782f, -1.5px 1.5px 0 #ff782f,
          1.5px -1.5px 0 #ff782f, -1.5px -1.5px 0 #ff782f;
      }
    }
    .type_container {
      // border: 1px solid red;
      width: 70%;
      margin: 40px auto 80px auto;
      display: flex;
      justify-content: space-around;
      .competition_type {
        cursor: pointer;
        img {
          margin-bottom: 20px;
          // border: 1px solid red;
          width: 120px;
        }
      }
    }

    .contentFrom_uls {
      padding: 30px 158px 0 158px;
      box-sizing: border-box;

      ul {
        width: 100%;
        background: #ffffff;

        li:last-child {
          border-bottom: none !important;
        }

        li {
          width: 100%;
          border-bottom: 1px solid #f2f2f2;
          .list {
            width: 100%;
            height: 68px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .listLeft {
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .listPan {
              position: relative;

              .posText {
                position: absolute;
                height: 1px;
                bottom: 0;
                right: 0;
                min-width: 50%;
                margin: auto;
                z-index: 1;

                ul {
                  width: 100%;
                  box-sizing: 0 1px 3px rgba(31, 35, 40, 0.12),
                    0 8px 24px rgba(66, 74, 83, 0.12);
                  border: 2px solid #f2f2f2;
                  max-height: 270px;
                  overflow-y: auto;

                  li {
                    height: 30px;
                    // line-height: 30px;
                    text-align: left;
                    padding: 10px;
                    box-sizing: border-box;
                    cursor: pointer;
                  }

                  li:hover {
                    background: #52a1ff;
                    color: #ffffff;
                  }
                }
              }
            }

            .listRight {
              width: 70%;
              height: 100%;
              position: relative;

              input {
                width: 100%;
                height: 100%;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #000000;
                border: none;
                text-align: right;
                background: none;
                padding: 0;
                box-sizing: border-box;
              }
              /* 隐藏步进器 */
              input[type="number"]::-webkit-inner-spin-button,
              input[type="number"]::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
              }

              input[type="number"] {
                -moz-appearance: textfield; /* Firefox */
              }

              input::-webkit-input-placeholder {
                color: #cccccc;
              }

              /* 使用webkit内核的浏览器 */
              input:-moz-placeholder {
                color: #cccccc;
              }

              /* Firefox版本4-18 */
              input::-moz-placeholder {
                color: #cccccc;
              }

              /* Firefox版本19+ */
              input:-ms-input-placeholder {
                color: #cccccc;
              }

              /* IE浏览器 */

              .listRight_xuan {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                text-align: right;
                justify-content: flex-end;
                color: #cccccc;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                cursor: pointer;

                .placeholderValue {
                  color: #000000 !important;
                }

                .listRight_icon {
                  margin-left: 10px;
                }

                .listRight_icontransform {
                  transform: rotate(180deg);
                }
              }
              .listRight_xuan_2 {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                text-align: right;
                justify-content: flex-end;
                color: #cccccc;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                cursor: pointer;

                .placeholderValue {
                  color: #000000 !important;
                  // 鼠标变为不可点击
                  cursor: not-allowed;
                }

                .listRight_icon {
                  margin-left: 10px;
                }

                .listRight_icontransform {
                  transform: rotate(180deg);
                }
              }

              .listRight_sji {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                text-align: right;
                justify-content: flex-end;
                color: #cccccc;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;

                .left {
                  font-size: 14px;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #333333;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  position: relative;
                  padding-right: 0.32rem;
                  box-sizing: border-box;

                  span:nth-child(1) {
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                    margin-right: 10px;
                  }

                  .left_formTwo {
                    transform: rotate(180deg);
                  }
                }

                .left:after {
                  content: " ";
                  width: 1px;
                  height: 20px;
                  background: #cccccc;
                  position: absolute;
                  top: 0;
                  right: 0;
                  bottom: 0;
                  margin: auto;
                }

                .right {
                  padding-left: 30px;
                  box-sizing: border-box;
                  width: 150px;
                  height: 100%;
                }
              }

              .listRight_sji2 {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                text-align: right;
                justify-content: flex-end;
                color: #cccccc;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;

                .right {
                  font-size: 14px;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #333333;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  position: relative;
                  padding-right: 30px;
                  box-sizing: border-box;
                }

                .right:after {
                  content: " ";
                  width: 1px;
                  height: 20px;
                  background: #cccccc;
                  position: absolute;
                  top: 0;
                  right: 0;
                  bottom: 0;
                  margin: auto;
                }
              }

              .selectBox {
                position: absolute;
                top: 100%;
                right: 0;
                min-width: 200px;
                min-height: 20px;
                background: #ffffff;
                z-index: 99;
                padding: 10px;
                border-radius: 10px;
                box-shadow: 0 2px 12px rgba(50, 50, 51, 0.12);
                display: flex;

                .selectBoxLeft {
                  width: 49%;
                  min-height: 30px;

                  .selectBox_uls {
                    width: 100%;
                    height: 100%;
                    overflow-y: hidden;
                    font-size: 14px;

                    .selectBox_lis {
                      width: 100%;
                      height: 30px;
                      display: flex;
                      align-items: center;
                      white-space: nowrap;
                    }
                  }
                }

                .selectBox_xian {
                  width: 1px;
                  background: #cccccc;
                  border-radius: 10px;
                }

                .selectBoxRight {
                  width: 49%;
                  min-height: 30px;
                  max-height: 300px;
                  margin-left: 10px;

                  .selectBox_uls {
                    width: 100%;
                    height: 100%;
                    font-size: 14px;
                    overflow-y: hidden;

                    .selectBox_lis {
                      width: 100%;
                      height: 30px;
                      display: flex;
                      align-items: center;
                      white-space: nowrap;
                    }
                  }
                }

                .selectBox_lis {
                  cursor: pointer;
                }

                .select_select {
                  color: red;
                }
              }
            }
            .beizhu {
              width: 100%;
              font-size: 13px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #e80202;
              margin-top: 8px;
              text-align: left;
              padding-bottom: 9px;
              box-sizing: border-box;
              margin-top: -10px;
            }
          }

          .list2 {
            width: 100%;

            .list2_uls {
              width: 100%;
              height: 68px;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .listLeft {
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }

              .listRight {
                width: 70%;
                height: 100%;
                display: flex;

                input {
                  width: 100%;
                  height: 100%;
                  font-size: 14px;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #000000;
                  border: none;
                  text-align: right;
                  background: none;
                  padding: 0;
                  box-sizing: border-box;
                }

                /* 隐藏步进器 */
                input[type="number"]::-webkit-inner-spin-button,
                input[type="number"]::-webkit-outer-spin-button {
                  -webkit-appearance: none;
                  margin: 0;
                }

                input[type="number"] {
                  -moz-appearance: textfield; /* Firefox */
                }

                input::-webkit-input-placeholder {
                  color: #cccccc;
                }

                /* 使用webkit内核的浏览器 */
                input:-moz-placeholder {
                  color: #cccccc;
                }

                /* Firefox版本4-18 */
                input::-moz-placeholder {
                  color: #cccccc;
                }

                /* Firefox版本19+ */
                input:-ms-input-placeholder {
                  color: #cccccc;
                }

                /* IE浏览器 */

                .listRight_xuan {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  text-align: right;
                  justify-content: flex-end;
                  color: #cccccc;
                  font-size: 14px;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  cursor: pointer;

                  .placeholderValue {
                    color: #000000 !important;
                  }

                  .listRight_icon {
                    margin-left: 10px;
                  }

                  .listRight_icontransform {
                    transform: rotate(180deg);
                  }
                }
              }
            }

            .beizhu {
              width: 100%;
              font-size: 13px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #e80202;
              margin-top: 8px;
              text-align: left;
              padding-bottom: 9px;
              box-sizing: border-box;
              margin-top: -10px;
            }
          }
        }
      }

      .uls_beizhu {
        font-size: 13px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #e80202;
        line-height: 18px;
        text-align: left;
      }
    }

    .promptInputValue {
      min-width: 100px;
      height: 68px;
      line-height: 68px;
      // padding-left: 13px;
      // box-sizing: border-box;
      // border: none;
      // background: #f5f5f5;
      // border-radius: 6px 6px 6px 6px;
      // font-size: 12px;
      // font-family: PingFang SC-Regular, PingFang SC;
    }

    .fromButtom {
      width: 360px;
      height: 50px;
      line-height: 50px;
      font-weight: 600;
      text-align: center;
      margin: 0 auto;
      margin-top: 32px;
      color: #ffffff;
      background-color: rgb(255, 120, 47);
      border-radius: 25px;
      letter-spacing: 2px;
      &:hover {
        cursor: pointer;
        opacity: 0.9;
        transition: background-color 0.3s ease;
      }
    }
    .last-step {
      margin: 20px 0;
      font-size: 14px;
      letter-spacing: 2px;
      color: rgb(255, 120, 47);
      span {
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
    .timeUp {
      width: 300px;
      height: 48px;
      margin: auto;
      margin-top: 32px;
      background: #d0d0d0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      cursor: not-allowed;
      font-size: 20px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 20px;
      box-shadow: 0px 4px 9px 0px rgba(208, 208, 208, 0.4);
      border-radius: 24px;
    }
  }
}

.views::-webkit-scrollbar {
  display: none;
}
.right2 {
  font-size: 14px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #52a1ff;
  display: flex;
  align-items: right;
  width: 79px;
  justify-content: right;
  cursor: pointer;
}
</style>
